import React from 'react'

import AuthLayout from '../components/Layout/AuthLayout'
import AuthSignupForm from '../components/Auth/Form/Signup'

export default function SignupPage(props) {
  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <AuthLayout>
      <AuthSignupForm {...props} />
    </AuthLayout>
  )
}
